import { render, staticRenderFns } from "./clsDetail.vue?vue&type=template&id=7e286640"
import script from "./clsDetail.vue?vue&type=script&lang=js"
export * from "./clsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports